(function () {
    angular.module('serviceResource', ['ngResource'])
        .factory('serviceResource', serviceResource);

    serviceResource.$inject = ['$resource'];
    function serviceResource($resource) {
        return {
            list: $resource('/api/service/:id', { id: '@id' })
        };
    }
})();